import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NeptuneApi } from '../genericApi/neptune.api';
import { DigestApi } from '@api/briefings/model/digest-api';
import { MultiBaseAbstractApi } from '@api/genericApi/multi-base-abstract.api';
import { DigestSubscriberApi } from '@api/briefings/model/digest-subscriber-api';
import { DigestPatchApi } from '@api/briefings/model/digest-patch-api';
import { DigestShareRequestApi } from '@api/briefings/model/digest-share-request-api';
import { HttpVerbsEnum } from '@api/shared/enums/http-verbs.enum';

@Injectable()
export class DigestApiService extends MultiBaseAbstractApi<DigestApi, DigestApi> {
    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<DigestApi[]> {
        return this.neptuneApi.api<DigestApi[]>(
            '/digests',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    create(resource: DigestApi): Observable<number> {
        return this.neptuneApi.api<number>(
            '/digests',
            resource,
            HttpVerbsEnum.POST
        );
    }

    getById(digestId: number): Observable<DigestApi> {
        return this.neptuneApi.api<DigestApi>(
            `/digests/${digestId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    update(resource: DigestApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/digests/${resource.id}`,
            resource,
            HttpVerbsEnum.PUT
        );
    }

    deleteById(digestId: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/digests/${digestId}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    deleteByIds(digestIds: number[]): Observable<null> {
        return this.neptuneApi.api<null>(
            `/digests/bulk?ids=${digestIds.join(',')}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    getDigestsByBriefingId(briefingId: number): Observable<DigestApi[]> {
        return this.neptuneApi.api<DigestApi[]>(
            `/digests/briefing/${briefingId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    getSubscribersByDigestId(digestId: number): Observable<DigestSubscriberApi[]> {
        return this.neptuneApi.api<DigestSubscriberApi[]>(
            `/digestsubscribers/digest/${digestId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    patchDigestsForBriefing(briefingId: number, digestPatchApi: DigestPatchApi): Observable<void> {
        return this.neptuneApi.api<void>(
            `/digests/patch-briefings/${briefingId}`,
            digestPatchApi,
            HttpVerbsEnum.PATCH
        );
    }

    shareDigest(digestId: number, digestShareRequest: DigestShareRequestApi) {
        return this.neptuneApi.api<number>(
            `/digests/share/${digestId}`,
            digestShareRequest,
            HttpVerbsEnum.POST
        );
    }
}
